import React from 'react';
import './styles.css';
import { Grid } from '@material-ui/core';
//CardFenomene estructura el titulo y los botones de cada componente interno usado en Fenomene Selection
const CardFenomene = ({ title, groupbutton }) => {
    return (
        <Grid className="CardFenomene">
            <Grid>
                <Grid className="TitleCardFenomene">
                    {title}
                </Grid>
                <Grid className="ContCardFenomene">
                    {groupbutton}
                </Grid>
            </Grid>
            <Grid className="espaciado">
                <hr></hr>
            </Grid>
        </Grid>
    )
}

export default CardFenomene;
